import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RedeemWindowService } from '../services/redeem-window.service';

/** Entry pages: if the customer still has a live code, send them back to it. */
export const redirectToShowcodeGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const redeemWindow = inject(RedeemWindowService);
  await redeemWindow.ready;

  return redeemWindow.isExpired() ? true : router.createUrlTree(['/code']);
};
